import { Box, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useScoreLabel } from 'pages/PlaygroundV2Page/hooks/useScoreLabel';
import SourceLabel from 'pages/PlaygroundV2Page/NoSourcesFoundComponent/components/SourceLabel';
import { DARK_GREY, DARKER_GREY } from 'utils/theme';

interface ClaimEvidenceHeaderProps {
  sourceIndex: number;
  evidence: Source;
  claimIndex?: number;
}
export const ClaimEvidenceHeader = ({
  sourceIndex,
  evidence,
  claimIndex,
}: ClaimEvidenceHeaderProps) => {
  const { getScoreLabel } = useScoreLabel();

  const label = getScoreLabel(evidence.softmaxScore[1]);
  const theme = useTheme();
  const indexText =
    claimIndex !== undefined && claimIndex !== null
      ? ` ${claimIndex + 1}.${sourceIndex + 1}`
      : ` ${sourceIndex + 1}.`;
  const isMobileScreen = useMediaQuery(theme.breakpoints.down('tablet'));
  return (
    <Stack
      direction="row"
      alignItems="flex-start"
      justifyContent="space-between"
      spacing={2}
      mb={2}
    >
      <Typography
        fontSize="18px"
        fontWeight="500"
        my={2}
        display="flex"
        flexDirection="row"
        alignItems="flex-start"
        pt="12px"
      >
        <Box
          component="span"
          fontWeight="300"
          fontSize="16px"
          paddingRight="4px"
          color={DARKER_GREY}
        >
          {indexText}
        </Box>{' '}
        <Box
          component="span"
          sx={{
            fontStyle: evidence.title ? 'normal' : 'italic',
            color: evidence.title ? 'inherit' : DARK_GREY,
          }}
        >
          {evidence.title || 'Headline not found'}
        </Box>
      </Typography>
      {!isMobileScreen && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            marginLeft: '24px',
          }}
        >
          <SourceLabel label={label} />
        </Box>
      )}
    </Stack>
  );
};

export default ClaimEvidenceHeader;
